import React from 'react';
import withTheme from '../../hocs/withTheme';
import './Badge.css';

type BadgeColor = 'default' | 'green' | 'yellow' | 'red';

interface BadgeProps {
    /** Text to be shown in the badge */
    title?: string;
    /** Define a badge color */
    color?: BadgeColor;
}

const Badge: React.FC<BadgeProps> = ({
    title = '',
    color = 'default',
}) => (
    <div className={`Badge badge__${color}`}>
        {title}
    </div>
);

export default withTheme(Badge);